module.exports = __webpack_public_path__ + "img/graphic-baking-bread-knife-brown.111538bc.jpg";